module.exports = __webpack_public_path__ + "static/media/favorite-2.67a6ff9b.svg";